enum BenefitEnquiries {
  Other = 'OTHER',
  ProportionsInAssetsPurchased = 'PROPORTION_IN_ASSETS_PURCHASED',
  RepayDebtsOrOtherObligations = 'REPAY_DEBTS_OR_OTHER_OBLIGATIONS',
}

enum CoApplicantBenefit {
  NoSubstantialBenefit = 'NO_SUBSTANTIAL_BENEFIT',
  NoSubstantialBenefitAndProceed = 'NO_SUBSTANTIAL_BENEFIT_AND_PROCEED',
  SubstantialBenefit = 'SUBSTANTIAL_BENEFIT',
}

export const CO_APPLICANT_BENEFIT_LABELS = [
  {
    label: 'You will receive a substantial benefit from the loan',
    value: CoApplicantBenefit.SubstantialBenefit,
  },
  {
    label:
      'You may not receive a substantial benefit from the loan and have confirmed you still want to proceed as a co-borrower',
    value: CoApplicantBenefit.NoSubstantialBenefitAndProceed,
  },
  {
    label: 'You will not receive a substantial benefit from the loan and do not want to proceed',
    value: CoApplicantBenefit.NoSubstantialBenefit,
  },
];

export const BENEFIT_ENQUIRIES_LABELS = [
  {
    label: 'You will acquire 50% or more legal or equitable interest in assets purchased with the loan funds',
    value: BenefitEnquiries.ProportionsInAssetsPurchased,
  },
  {
    label: 'You will use 50% or more of the loans to repay your debts or other obligations owed by you',
    value: BenefitEnquiries.RepayDebtsOrOtherObligations,
  },
  {
    label: 'Other',
    value: BenefitEnquiries.Other,
  },
];

enum CoApplicantReason {
  AccessToCashOrEquity = 'ACCESS_TO_CASH_OR_EQUITY',
  BuyingAVehicalWhereOnlyOneBorrowerCanBeTheRegisteredOwner = 'BUYING_A_VEHICLE_WHERE_ONLY_ONE_BORROWER_CAN_BE_THE_REGISTERED_OWNER',
  IndependentFinancialLegalOrAccountingAdviceRequired = 'INDEPENDENT_FINANCIAL_LEGAL_OR_ACCOUNTING_ADVICE_RECEIVED',
  SpousalAssetProtectionTaxBenefitsOrDebtReduction = 'SPOUSAL_ASSET_PROTECTION_TAX_BENEFITS_OR_DEBT_REDUCTION',
  SubstantialBenefitFromAtLeastOneOfTheLoanPurposes = 'SUBSTANTIAL_BENEFIT_FROM_AT_LEAST_ONE_OF_THE_LOAN_PURPOSES',
}

export const CO_APPLICANT_REASON_LABELS = [
  {
    label: 'Spousal asset protection, tax benefits or debt reduction',
    value: CoApplicantReason.SpousalAssetProtectionTaxBenefitsOrDebtReduction,
  },
  {
    label: 'Independent financial, legal or accounting advice received',
    value: CoApplicantReason.IndependentFinancialLegalOrAccountingAdviceRequired,
  },
  {
    label: 'Substantial benefit from at least one of the loan purposes',
    value: CoApplicantReason.SubstantialBenefitFromAtLeastOneOfTheLoanPurposes,
  },
  {
    label: 'Access to cash or equity (e.g. personal investments, goods or travel)',
    value: CoApplicantReason.AccessToCashOrEquity,
  },
  {
    label: 'Buying a vehicle where only one borrower can be the registered owner',
    value: CoApplicantReason.BuyingAVehicalWhereOnlyOneBorrowerCanBeTheRegisteredOwner,
  },
];

enum LocationType {
  CustomerResidence = 'CUSTOMER_RESIDENCE',
  LendiApprovedPhoneInterview = 'LENDI_APPROVED_PHONE_INTERVIEW',
  Other = 'OTHER',
}

export {
  BenefitEnquiries as BENEFIT_ENQUIRIES,
  CoApplicantBenefit as CO_APPLICANT_BENEFIT,
  CoApplicantReason as CO_APPLICANT_REASON,
  LocationType as LOCATION_TYPE,
};
